import { render, staticRenderFns } from "./contact-types.vue?vue&type=template&id=962e8dec&"
import script from "./contact-types.vue?vue&type=script&lang=js&"
export * from "./contact-types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports